import type { KambiBetOffer, KambiEvent } from '@mobi/api-types/kambi'
import { get } from '@classic/Foundation/Services/ApiService'

export const getKambiBetOffersByIds = ({ betOfferIds }: { betOfferIds: number[] }) =>
  get<KambiBetOffersByIdsResponse>({
    url: `${window._kc.apiOfferingBaseUrl}betoffer/${betOfferIds.join(',')}`,
  })

// =====
// Types
// =====

type KambiBetOffersByIdsResponse = {
  betOffers: KambiBetOffer[]
  events: KambiEvent[]
  /** Represents a pre pack @todo determine if required */
  prePacks: never
  range: {
    start: number
    size: number
    total: number
    hasNext: boolean
  }
}
